export const environment = {
  production: false,
  apiUrl: '//dev-api-hotel.m.com.mx',
};
